import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from '@forge/common';
import { VIEW_COURSE } from '../../../view-course-templates/utils/constants';

interface DuplicateCourseProps {
  isOpen: boolean;
  courseId: string;
  onClose: () => void;
  onCancel?: () => void;
  onContinue?: (courseId: string | number) => void;
  title?: string;
  message?: {
    line1?: string;
    line2?: string;
  };
  cancelButtonText?: string;
  continueButtonText?: string;
  customNavigationPath?: string;
}

const DuplicateCourse: React.FC<DuplicateCourseProps> = ({
  isOpen,
  courseId,
  onClose,
  onCancel,
  onContinue,
  title = "Duplicate Course",
  message = {
    line1: VIEW_COURSE.DUPLICATE.DUPLICATE_COURSE_MESSAGE_LINE1,
    line2: VIEW_COURSE.DUPLICATE.DUPLICATE_COURSE_MESSAGE_LINE2
  },
  cancelButtonText = VIEW_COURSE.DUPLICATE.CANCEL,
  continueButtonText = VIEW_COURSE.DUPLICATE.CONTINUE,
  customNavigationPath
}) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };

  const handleContinue = () => {
    if (onContinue) {
      onContinue(courseId);
    } else {
      const navigationPath = customNavigationPath || `/academy/copyCourse/${courseId.toString()}`;
      navigate(navigationPath);
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      backdrop
      footerLeft={
        <div className="flex justify-center">
          <Button
            className="text-base font-bold mr-4"
            id="confirm-cancel-copy-course"
            data-testid="confirm-cancel-copy-course"
            onClick={handleCancel}
            size="regular"
            variant="secondary"
          >
            {cancelButtonText}
          </Button>
          <Button
            className="text-base font-bold"
            id="continue-copy-course"
            data-testid="continue-copy-course"
            onClick={handleContinue}
            size="regular"
            variant="primary"
          >
            {continueButtonText}
          </Button>
        </div>
      }
      onModalClose={onClose}
      title={title}
    >
      {message.line1} <br /> {message.line2}
    </Modal>
  );
};

export default DuplicateCourse;